import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

export function EnergyCalculationMissing(): React.ReactElement {
  const { t } = useTranslation()

  return (
    <Box m={1}>
      <Typography>{t('error.energyCalculationMissing')}</Typography>
    </Box>
  )
}
